<!-- HEADER SECTION -->
<cmps-sc-header
    [tabs]="state?.tabs"
    [tab]="state?.selectedTab"
    [useLiveData]="state?.selectedTab?.useLiveData"
    (tabCreate)="_onTabCreate($event)"
    (tabChange)="_onTabChange($event)"
    (tabClose)="_onTabClose($event)"
    (exportScorecard)="_onExportScorecard()"
    (toggleUseLiveData)="_onToggleUseLiveData($event)"
    *ngIf="!_fromInsightCard"
></cmps-sc-header>
<!-- END -->
<div class="sc-container-main">
    <cmps-wait-status
        [status]="
            _i18n._9350_THIS_USER_S_SCORECARDS_ARE_BEING_PRESENTED_FOR_THE_FIRST_TIME__PLEASE_WAIT_
                | translate
        "
        *ngIf="state?.selectedTab?.pending?.reload && _longPendingReload"
    ></cmps-wait-status>
    <div
        class="my-3 text-center"
        *ngIf="
            !state?.selectedTab?.pending?.reload &&
            !state?.selectedTab?.selectedScorecardHistory
        "
    >
        {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
    </div>
    <cmps-scorecard-trend-chart-widget
        [periodTypes]="state?.selectedTab?.periodTypes"
        [scorecardHistoryData]="state?.selectedTab?.selectedScorecardHistory"
        [scorecardTrendChartRootDefinition]="state?.selectedTab?.rootConfig"
        [selectedPeriodType]="
            state?.selectedTab?.selectedPeriodType?.periodTypeId
        "
        [selectedScorecard]="state?.selectedTab?.selectedScorecard"
        [selectedTabId]="state?.selectedTab?.tabId"
        [fromInsightCard]="_trendMode"
        (onPeriodTypeChange)="_onPeriodTypeChange($event)"
        (onPeriodTypeFocus)="_onPeriodTypeFocus()"
        (onVerticalBarSelectionChange)="_onScorecardChange($event)"
        *ngIf="
            state?.selectedTab?.selectedPeriodType &&
            state?.selectedTab?.selectedScorecardHistory &&
            state?.selectedTab?.selectedScorecard &&
            (!_fromInsightCard || _trendMode)
        "
        class="cmps-scorecard-trend-chart-widget-scorecard"
    >
    </cmps-scorecard-trend-chart-widget>
    <!--TODO notify the user when they switch to a non-initial scorecard and the data isn't ready yet-->
    <!--TODO notify the user when they switch to a non-initial period type and the data isn't ready yet-->
    <div
        [style.display]="
            this.state?.selectedTab?.selectedScorecard && !_trendMode
                ? 'block'
                : 'none'
        "
        class="mb-3 pb-3"
        id="scorecard-widgets-container"
    >
        <cmps-container>
            <cmps-container-stripe
                [color]="containerColour"
            ></cmps-container-stripe>
            <cmps-container-header>
                <div class="row pt-3 pr-3 pb-3 pl-2 scorecard-header-logo">
                    <div class="col-12 col-sm-12 col-md-2 col-lg-1 col-xl-2">
                        <div class="cmps-scorecard-container-logo">
                            <img
                                [src]="
                                    this.state?.selectedTab?.logoUrl ??
                                    'assets/orbit-group-logo-icon.svg'
                                "
                                alt
                                role="presentation"
                                onerror="this.onerror = null; this.style.display = 'none';"
                            />
                        </div>
                        <span class="cmps-scorecard-container-username">{{
                            _i18n._9889_NAME_SCORECARD
                                | translate
                                    : {
                                          name: this.state?.selectedTab?.user
                                              ?.firstName
                                      }
                        }}</span>
                    </div>
                    <div
                        class="col-12 col-sm-12 col-md-10 col-lg-7 col-xl-6 scorecard-header-tabs"
                    >
                        <div class="row">
                            <div
                                class="col-12 col-sm-12 col-md-6 col-lg-7 col-xl-7"
                            >
                                <cmps-tabset-label-wrapper
                                    *ngIf="
                                        state?.selectedTab?.directReportGrids
                                            ?.length
                                    "
                                >
                                    <ng-template cmpsTabLabel>
                                        <button
                                            cmpsTabButton
                                            class="mr-2"
                                            theme="b"
                                            [selected]="
                                                state.selectedTab
                                                    ?.selectedGridTab ===
                                                _GridTab.SCORECARD_GRID
                                            "
                                            (click)="
                                                $event.stopPropagation();
                                                _onGridTabChange(
                                                    _GridTab.SCORECARD_GRID
                                                )
                                            "
                                        >
                                            <span cmpsTabButtonLabel>{{
                                                _i18n._9892_SCORECARD_GRID
                                                    | translate
                                            }}</span>
                                        </button>
                                    </ng-template>
                                    <ng-template cmpsTabLabel>
                                        <button
                                            cmpsTabButton
                                            theme="b"
                                            [selected]="
                                                state.selectedTab
                                                    ?.selectedGridTab ===
                                                _GridTab.DIRECT_REPORT_VIEW
                                            "
                                            (click)="
                                                $event.stopPropagation();
                                                _onGridTabChange(
                                                    _GridTab.DIRECT_REPORT_VIEW
                                                )
                                            "
                                        >
                                            <span cmpsTabButtonLabel>{{
                                                _i18n._9893_DIRECT_REPORT_VIEW
                                                    | translate
                                            }}</span>
                                        </button>
                                    </ng-template>
                                </cmps-tabset-label-wrapper>
                            </div>
                            <div
                                class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-5 d-flex justify-content-center"
                            >
                                <select
                                    class="sc-select ml-3"
                                    [hidden]="
                                        state?.selectedTab?.selectedGridTab ===
                                        _GridTab.SCORECARD_GRID
                                    "
                                    [ngModel]="
                                        state?.selectedTab
                                            ?.selectedDirectReportDropdownItem
                                    "
                                    (ngModelChange)="
                                        _onDropdownGridViewChange($event)
                                    "
                                >
                                    <option
                                        class="text-left"
                                        *ngFor="
                                            let reportGrid of this.state
                                                ?.selectedTab?.directReportGrids
                                        "
                                        [value]="reportGrid.gridType"
                                    >
                                        {{
                                            _directReportViewTranslationKeyMap[
                                                reportGrid.gridType
                                            ] | translate
                                        }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-12 col-sm-12 col-md-8 col-lg-4 col-xl-4 scorecard-header-buttons text-right ml-mid-auto"
                    >
                        <div class="d-flex justify-content-end">
                            <button
                                class="cmps-button--sm p-1"
                                cmpsButton
                                (click)="_onExpandAllClick($event)"
                                [hidden]="
                                    state?.selectedTab?.selectedGridTab ===
                                        _GridTab.SCORECARD_GRID ||
                                    !_showExpandAllBtn
                                "
                            >
                                <cmps-icon
                                    [svgIcon]="
                                        _expandLabelToggle
                                            ? 'arrow-expand'
                                            : 'arrow-collapse'
                                    "
                                ></cmps-icon>
                                <span cmpsButtonLabel>
                                    {{
                                        _expandLabelToggle
                                            ? (_i18n._9397_EXPAND_ALL_
                                              | translate)
                                            : (_i18n._9396_COLLAPSE_ALL_
                                              | translate)
                                    }}</span
                                >
                            </button>
                            <button
                                class="ml-2 cmps-button--sm p-1"
                                cmpsButton
                                (click)="_onResetClick($event)"
                            >
                                <cmps-icon svgIcon="cached"></cmps-icon>
                                <span cmpsButtonLabel>{{
                                    _i18n._9395_RESET_GRID | translate
                                }}</span>
                            </button>
                            <button
                                class="ml-2 cmps-button--sm p-1"
                                cmpsButton
                                (click)="_onExportWidgetsClick($event)"
                            >
                                <cmps-icon svgIcon="download"></cmps-icon>
                                <span cmpsButtonLabel>{{
                                    _i18n._9391_EXPORT_DATA | translate
                                }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </cmps-container-header>
            <cmps-container-content
                [hidden]="
                    state?.selectedTab?.selectedGridTab ===
                    _GridTab.DIRECT_REPORT_VIEW
                "
            >
                <div class="row mb-3 pl-2 pr-2">
                    <div class="col-12 col-md-2">
                        <strong
                            >{{
                                _i18n._804_SUPERGROUP_ | translate
                            }}&nbsp;</strong
                        >
                        <span>{{
                            this.state.selectedTab.selectedScorecard?.header
                                ?.groupName
                        }}</span>
                    </div>
                    <div class="col-12 col-md-4">
                        <div>
                            <strong>{{ _i18n._773_PERIOD | translate }}</strong>
                            <strong class="sc-grid-font-period ml-2 mr-2">{{
                                _i18n._9250_FROM | translate
                            }}</strong>
                            <span class="mr-1">{{
                                this.state.selectedTab.selectedScorecard?.header
                                    ?.startDate | cmpsDate: 'MM-dd-y'
                            }}</span>
                            <strong class="sc-grid-font-period mr-2">{{
                                _i18n._9253_TO | translate
                            }}</strong>
                            <span class="mr-1">{{
                                this.state.selectedTab.selectedScorecard?.header
                                    ?.endDate | cmpsDate: 'MM-dd-y'
                            }}</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-2">
                        <strong
                            >{{ _i18n._9351_SCORECARD_ID | translate }}:
                        </strong>
                        <span>{{
                            this.state.selectedTab.selectedScorecard?.header
                                ?.scorecardId
                        }}</span>
                    </div>
                    <div class="col-12 col-md-2">
                        <strong
                            >{{ _i18n._9352_SCORECARD_STATUS | translate }}:
                        </strong>
                        <strong
                            [class.status-published]="
                                this.state.selectedTab.selectedScorecard?.header
                                    ?.published
                            "
                            [class.status-unpublished]="
                                !this.state.selectedTab.selectedScorecard
                                    ?.header?.published
                            "
                        >
                            {{
                                (this.state.selectedTab.selectedScorecard
                                    ?.header?.published
                                    ? _i18n._9113_PUBLISHED
                                    : _i18n._9114_UNPUBLISHED
                                ) | translate
                            }}
                        </strong>
                    </div>
                    <div class="col-12 col-md-2">
                        <strong
                            >{{ _i18n._9388_GENERATED_ON | translate }}:
                        </strong>
                        <span>{{
                            this.state.selectedTab.selectedScorecard?.header
                                ?.generatedOn | cmpsDate: 'MM-dd-y h:mm:ss a'
                        }}</span>
                    </div>
                </div>
                <div>
                    <ng-container #ref></ng-container>
                </div>
            </cmps-container-content>
            <cmps-container-content
                [hidden]="
                    state?.selectedTab?.selectedGridTab ===
                    _GridTab.SCORECARD_GRID
                "
            >
                <div>
                    <ng-container #teamGridRef></ng-container>
                </div>
            </cmps-container-content>
        </cmps-container>
    </div>
</div>
